<template>
  <div class="pagination">
    <button 
      class="button-side" 
      :class="{'active': prevActive}"
      @click="prev"
      >Prev
    </button>
    <button 
      class="pages" 
      :class="{'active': currentPage === d, 'page-ellipsis': d === '...'}" 
      v-for="(d,k) in pages" :key="'page'+k" 
      @click="gotoPage(d)"
      >{{d}}
    </button>
    <button 
      class="button-side"
      :class="{'active': nextActive}"
      @click="next"
      >Next
    </button>
    <div class="j_pagination_status">
      <span class="_current">{{pagination.page}}</span>
      <span> / </span>
      <span class="total-page">{{totalPages}}</span>
      <span> ( </span>
      <span class="total-row">{{pagination.totalRows}}</span>
      <span> items )</span>
    </div>
    
    
    
  </div>
</template>
<script>

export default {
  name: 'j-pagination-box',
  props: {
    sideslide: Boolean,
    showStatus: { type: Boolean, default: true },
    pagination: { type: Object, default: {} },
  },
  // {
  //   "page": 1,
  //   "rowsPerPage": 40,
  //   "  ": 126
  // }
  // ['value', 'totalRow', 'pageSize'],
  data () {
    return {
      viewpages: [40, 80, 120, 160],
      totalPages: null,
      maxPages: 10,
      currentPage: 1,
      startPage: 0,
      endPage: 9,
      pages: []
    }
  },  
  computed: {
    prevActive() {
      return this.currentPage === 1
    },
    nextActive() {
      return this.currentPage === this.totalPages
    },
  },
  watch: {
    pagination: {
      handler (v) {
        if((!v) || Object.keys(v).length === 0) return
        this.totalPages = Math.ceil(this.pagination.totalRows / this.pagination.rowsPerPage)
        this.currentPage = this.pagination.page
        this.paginationBox()
      },
      deep: true,
      immediate: true
    },
    currentPage (v) {
      if (v < 1) {
        this.currentPage = 1
      } else if (v >= this.totalPages) {
        this.currentPage = this.totalPages
      }
      this.paginationBox()
      if (v >= 1 && v <= this.totalPages) {
        this.$emit('input', v)
      }
    },
    pageSize (v) {
      this.totalPages = Math.ceil(this.pagination.totalRows / this.pagination.rowsPerPage)
      this.paginationBox()
    },
  },
  methods: {
    paginationBox () {
      if (this.totalPages <= this.maxPages) {
        this.startPage = 1
        this.endPage = this.totalPages
      } else {
        let maxPagesBeforeCurrentPage = Math.floor(this.maxPages / 2)
        let maxPagesAfterCurrentPage = Math.ceil(this.maxPages / 2) - 1
        if (this.currentPage <= maxPagesBeforeCurrentPage) {
          this.startPage = 1
          this.endPage = this.maxPages
        } else if (this.currentPage + maxPagesAfterCurrentPage >= this.totalPages) {
          this.startPage = this.totalPages - this.maxPages + 1
          this.endPage = this.totalPages
        } else {
          this.startPage = this.currentPage - maxPagesBeforeCurrentPage
          this.endPage = this.currentPage + maxPagesAfterCurrentPage
        }
      }
      // let startIndex = (this.currentPage - 1) * this.pageSize
      // let endIndex = Math.min(startIndex + this.pageSize - 1, this.totalRow - 1)

      let pages = Array.from(Array((this.endPage + 1) - this.startPage).keys()).map(i => this.startPage + i)
      if (pages.indexOf(this.totalPages) < 0) {
        pages.splice(pages.length - 2, 1, '...')
        pages.splice(pages.length - 1, 1, this.totalPages)
        this.pages = pages
      } else {
        this.pages = pages
      }
      if (pages.indexOf(1) < 0) {
        pages.splice(1, 1, '...')
        pages.splice(0, 1, 1)
        this.pages = pages
      } else {
        this.pages = pages
      }
    },
    gotoPage (d) {
      if (d !== '...') this.currentPage = d
      this.$emit('page', Number(d))
    },
    prev() {
      if (this.prevActive) return
      this.$emit('previous', Number(this.pagination.page) - 1)
    },
    next() {
      if (this.nextActive) return
      this.$emit('next', Number(this.pagination.page) + 1)
    },
    gotoPage (d) {
      if (d !== '...') this.currentPage = d
      this.$emit('page', Number(d))
    },
  }
}
</script>
<style lang="scss" scoped>
$base-color: #00ADEE;
$board-outer: mix(#fff, $base-color, 70%);
$board-inner: mix(#fff, $base-color, 90%);
$board-background: mix(#fff, $base-color, 90%);
$board-page-active: #3b3b3b;
$board-gray: #ddd;

.pagination {
  padding: 5px 0;
  display: flex;
  align-items: center;
  justify-content: flex-start;
}

.pagination button {
  user-select: none;
  cursor: pointer;
  border: 1px solid #e1e1e1;
  border-radius: .3em;
  background-color: #fefefe;
  font-size: 0.8rem;
  font-weight: normal;
  text-align: center;
  text-decoration: none;
  color: #717171;
  width: 20px;
  height: 20px;
  margin: 0 2px;

  &.page-ellipsis {
    border: #fff;
    cursor: default;
  }
  &.button-side {
    width: 28px;
    padding: 0;
  }
  &.pages:hover:not(.page-ellipsis):not(.active) {
    background-color: #eee;
  }

  &:focus,
  &:active{
    outline: none;
  }
  &:active{
    border: none;
    background: #fefefe;
  }

  &.active {
    border: none;
    background: mix(#fff, $board-page-active, 10%);
    color: #f0f0f0;
    font-weight: bold;
    cursor: default;
  }
}
.options-rowsperpage {
  margin-left: 30px;
  button {
    user-select: none;
    cursor: pointer;
    border: 1px solid #e1e1e1;
    border-radius: .3em;
    background-color: #fefefe;
    font-size: 0.8rem;
    font-weight: normal;
    text-align: center;
    text-decoration: none;
    color: #717171;
    width: 20px;
    height: 20px;
    margin: 0 2px;

    &:focus, &:active{
      outline: none;
    }
    &:active {
      border: none;
      background: #fefefe;
    }
    &.active {
      border: none;
      background: mix(#fff, #3b3b3b, 10%);
      color: #fffefe;
      font-weight: bold;
      cursor: default;
    }
  }
}
.j_pagination_status {
  font-size: 0.9rem;
  margin-left: 10px;
  margin-right: 10px;
  color: #bbdefb;
  ._current {
    font-size: 1.2rem;
    color: #fff;
  }
}
</style>
